import angular from "angular";
import { directiveFactory } from "../angular-core";

export class TableNavigationDirective implements ng.IDirective {
    static componentName: string = "tablenavigation";
    link = (scope: $TSFixMe, element: JQLite) => {
        element.on("keydown.mynavigation", 'input[type="text"]', handleNavigation);
        function handleNavigation(e: $TSFixMe) {
            const arrow = { left: 37, up: 38, right: 39, down: 40 };

            // select all on focus
            element.find("input").keydown(function (e: $TSFixMe) {
                // shortcut for key other than arrow keys

                let td = $(e.target).closest("td");
                let moveTo = null;
                switch (e.which) {
                    case arrow.left: {
                        moveTo = td.prev("td:has(input)");
                        break;
                    }
                    case arrow.right: {
                        moveTo = td.next("td:has(input)");
                        break;
                    }
                    case arrow.up:
                    case arrow.down: {
                        let tr = td.closest("tr");
                        let pos = td[0].cellIndex;

                        let moveToRow = null;
                        if (e.which == arrow.down) {
                            moveToRow = tr.next("tr");
                        } else if (e.which == arrow.up) {
                            moveToRow = tr.prev("tr");
                        }
                        if (moveToRow?.length) {
                            moveTo = $(moveToRow[0].cells[pos]);
                        }
                        break;
                    }
                }

                if (moveTo && moveTo.length) {
                    e.preventDefault();
                    moveTo.find("input").each(function (i: $TSFixMe, input: $TSFixMe) {
                        input.focus();
                        input.select();
                    });
                }
            });

            const key = e.keyCode ? e.keyCode : e.which;
            if (key === 13) {
                var focusedElement = $(e.target);
                var nextElement = focusedElement.parent().next();
                if (nextElement.find("input").length > 0) {
                    nextElement.find("input").focus();
                } else {
                    nextElement = nextElement.parent().next().find("input").first();
                    nextElement.focus();
                }
            }
        }
    };
}

angular
    .module("topline.directives")
    .directive(TableNavigationDirective.componentName, directiveFactory(TableNavigationDirective));
